/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum PaxCheckChecklistItemStatus {
    NOT_YET_RESOLVED = 'NOT_YET_RESOLVED',
    RESOLVED = 'RESOLVED',
    VERIFICATION_REQUIRED = 'VERIFICATION_REQUIRED'
}


export function instanceOfPaxCheckChecklistItemStatus(value: any): boolean {
    for (const key in PaxCheckChecklistItemStatus) {
        if (Object.prototype.hasOwnProperty.call(PaxCheckChecklistItemStatus, key)) {
            if (PaxCheckChecklistItemStatus[key as keyof typeof PaxCheckChecklistItemStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PaxCheckChecklistItemStatusFromJSON(json: any): PaxCheckChecklistItemStatus {
    return PaxCheckChecklistItemStatusFromJSONTyped(json, false);
}

export function PaxCheckChecklistItemStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckChecklistItemStatus {
    return json as PaxCheckChecklistItemStatus;
}

export function PaxCheckChecklistItemStatusToJSON(value?: PaxCheckChecklistItemStatus | null): any {
    return value as any;
}

export function PaxCheckChecklistItemStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): PaxCheckChecklistItemStatus {
    return value as PaxCheckChecklistItemStatus;
}

